import React from 'react';
import {
  Typography,
  Box,
  IconButton,
  Tooltip,
  ListItem,
  ListItemText,
} from '@mui/material';
import {
  Delete as DeleteIcon,
  RestoreFromTrash as RestoreIcon,
} from '@mui/icons-material';
import useAppStore from 'store/useAppStore';
import api from 'services/api';
const RenderHistoryItem = ({ segScriptId, version, handleRestoreVersion }) => {
  const showNotification = useAppStore((state) => state.showNotification);
  const [deleteDBSegScript, { isLoading: isDeleteDBSegScriptLoading }] =
    api.endpoints.deleteDBSegScript.useMutation();
  const handleDeleteVersion = async (version) => {
    deleteDBSegScript({
      seg_script_name: version.script_name || '',
      project_id: useAppStore.getState().selectedProject.project_id || '',
      seg_script_id: segScriptId,
      user_id: useAppStore.getState().user.id || '',
      comp_name: useAppStore.getState().user.company || '',
      edit_time: version.edit_time,
    })
      .unwrap()
      .then(() => {
        showNotification('版本刪除成功！', 'success');
      })
      .catch((error) => {
        showNotification(error.message || '刪除版本失敗', 'error');
      });
  };
  return (
    <ListItem
      sx={{ border: '1px solid #e0e0e0', borderRadius: 1, mb: 1, gap: 2 }}
    >
      <ListItemText
        primary={
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Typography variant="subtitle2" fontWeight="bold">
              {version.script_name}
            </Typography>
          </Box>
        }
        secondary={
          <Tooltip
            title={version.script.replace(/<br>/g, '\n')}
            placement="top"
            classes={{
              tooltip: 'whitespace-pre-wrap max-w-[400px]',
            }}
          >
            <Box
              component="span"
              sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                color: 'text.secondary',
                fontSize: '0.875rem',
                lineHeight: 1.43,
                display: 'block',
              }}
            >
              {version.script.replace(/<br>/g, '\n')}
            </Box>
          </Tooltip>
        }
      />
      <Box sx={{ display: 'flex', flex: '0 0 auto', gap: 1 }}>
        <Typography variant="caption" color="text.secondary">
          {version.edit_time}
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', gap: 1 }}>
        <Tooltip title="覆蓋當前內容">
          <IconButton
            size="small"
            onClick={() => handleRestoreVersion(version)}
          >
            <RestoreIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="刪除版本">
          <IconButton
            size="small"
            onClick={() => handleDeleteVersion(version)}
            color="error"
            loading={isDeleteDBSegScriptLoading}
          >
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      </Box>
    </ListItem>
  );
};
export default RenderHistoryItem;
